import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div>
      <Backdrop
        sx={{ color: "primary", zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#fff' }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default Loading;
